import React from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import styled from 'styled-components'
import { DropdownCopytradingAppInfo, DropdownCopytradingNavigate, DropdownCopytradingTopTraders } from './components'

export const DropdownCopytrading = () => {
  return (
    <StyledDropdownCopytrading>
      <DropdownCopytradingAppInfo />
      <DropdownCopytradingTopTraders />
      <DropdownCopytradingNavigate />
      <StyledReactTooltip id='copytrading-header-tooltip' />
    </StyledDropdownCopytrading>
  )
}

const StyledDropdownCopytrading = styled.div`
  direction: ltr;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 967px;
  height: 600px;
  border-radius: 8px;
  background: linear-gradient(0deg, #f3f7fd, #f3f7fd), #123482;
  cursor: default;
`

const StyledReactTooltip = styled(ReactTooltip)`
  background-color: #f3f7fd;
  opacity: 1;
  border-radius: 8px;
  filter: drop-shadow(0px 4px 12px rgba(15, 42, 102, 0.35));
`
